import React from 'react';
import store from '../../store/configuration';
import EditorMobileNavigationDrawer from './EditorMobileNavigationDrawer';
import EditorMobileNavigationBar from './EditorMobileNavigationBar';

export default class EditorMobileNavigation extends React.PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            drawerVisible: false
        }
    }

    onDrawerToggleClick = () => {
        this.setState({
            drawerVisible: !this.state.drawerVisible
        });
    }

    render() {
        let availableSteps = store.getAvailableSteps()
        let stepIndex = availableSteps.findIndex(x => x.slug === this.props.currentStep);
        let step = availableSteps[stepIndex];

        return (
            <div className="configuration-editor-mobile-nav">
                <EditorMobileNavigationDrawer
                    visible={this.state.drawerVisible}
                    availableSteps={availableSteps}
                    currentStepIndex={stepIndex}
                    configurator={this.props.configurator}
                />

                <EditorMobileNavigationBar
                    {...this.props}
                    availableSteps={availableSteps}
                    currentStep={step}
                    currentStepIndex={stepIndex}
                    onDrawerToggleClick={this.onDrawerToggleClick}
                />
            </div>
        )
    }
}